module.exports = __webpack_public_path__ + "static/sioux-falls-79becfd0f6cb2f81a50c521f6cf8da85.png";